// extracted by mini-css-extract-plugin
export default {"preview-container":"preview-container--yIYa8","preview-text-container":"preview-text-container--MfFzk"};